export default {
  title: 'Order Request List',

  elements: [
    {
      type: 'dataTable',
      config: {
        listActions: [],
        rowActions: [
          {
            type: 'detail'
          },
          {
            type: 'delete'
          }
        ],
        filters: {
          fields: [
            {
              span: 4,
              label: 'To supplier',
              name: 'filter[supplier_id]',
              type: 'lazySelect',
              searchable: true,
              inlineLabel: true,
              displayAttr: 'screen_name',
              selectedOptionAttr: 'supplier',
              request: {
                endpoint: 'suppliers',
                params: { sort: 'screen_name', nopagination: true },
                dataPath: 'data'
              },
              selectedWidget: {
                widget: 'card',
                main: 'screen_name',
                image: {
                  field: 'logo_url',
                  width: 20,
                  height: 20
                }
              },
              optionWidget: {
                widget: 'card',
                main: 'screen_name',
                image: {
                  field: 'logo_url',
                  width: 20,
                  height: 20
                }
              }
            },
            {
              span: 4,
              label: 'Search terms',
              name: 'filter[term]'
            }
          ]
        },
        url: 'order-requests',
        defaultParams: {
          sort: '-created_at'
        },
        response: {
          mappers: {
            list: 'data'
          }
        },
        tabs: [
          {
            id: 'all',
            label: 'All',
            requestParams: {}
          },
          {
            id: 'draft',
            label: 'Drafts',
            requestParams: {
              'filter[status]': 'draft'
            }
          },
          {
            id: 'pending',
            label: 'Pending',
            requestParams: {
              'filter[status]': 'pending'
            }
          },
          {
            id: 'accepted',
            label: 'Accepted',
            requestParams: {
              'filter[status]': 'accepted'
            }
          },
          {
            id: 'rejected',
            label: 'Rejected',
            requestParams: {
              'filter[status]': 'rejected'
            }
          }
        ],
        pagination: {
          mappers: {
            count: 'meta.total',
            perPage: 'meta.per_page'
          }
        },
        columns: [
          {
            label: 'Type',
            widget: {
              widget: 'card',
              main: {
                widget: 'identifierLabel',
                field: 'reference'
              },
              secondary: {
                widget: 'text',
                field: 'type'
              }
            }
          },
          {
            label: 'Status',
            field: 'status'
          },
          {
            label: 'Title',
            field: 'title'
          },
          {
            label: 'To Supplier',
            widget: {
              widget: 'card',
              main: {
                widget: 'text',
                field: 'supplier.screen_name'
              },
              image: {
                widget: 'logo',
                field: 'supplier.logo_url',
                width: 40,
                height: 40
              }
            }
          },
          {
            label: 'From Buyer',
            field: 'buyer.display_name'
          },
          {
            label: '# Messages',
            sortable: true,
            field: 'messages_count'
          },
          {
            label: 'Created at',
            field: 'created_at',
            widget: 'datetime',
            sortable: true
          },
          {
            label: 'Sent at',
            field: 'sent_at',
            widget: 'datetime',
            sortable: true
          }
        ]
      }
    }
  ]
};
